import { render, staticRenderFns } from "./contract-type-dialog.vue?vue&type=template&id=715b84cc&scoped=true"
import script from "./contract-type-dialog.vue?vue&type=script&lang=js"
export * from "./contract-type-dialog.vue?vue&type=script&lang=js"
import style0 from "./contract-type-dialog.vue?vue&type=style&index=0&id=715b84cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b84cc",
  null
  
)

export default component.exports